import config from "../config";
import * as Sentry from "@sentry/react";

// Единая точка шеринга приложения. Раньше логика была продублирована в
// BurgerMenu/viewController.js и modals/FeedbackModal/controller.js и разъехалась
// (title "Wepurplay" vs "InTouch") — теперь все точки (меню, ЛК, конец игры) зовут сюда.

// Per-user реф-ссылка: ?ref=<refCode> ловится на входе и передаётся при регистрации
// (начисление 1000 баллов пригласившему за коннект).
export function buildShareLink(refCode) {
  return refCode
    ? `${config.generatedBaseLink}?ref=${encodeURIComponent(refCode)}`
    : config.generatedBaseLink;
}

// RN WebView (SHARE_API) → navigator.share → clipboard-фолбэк.
// Возвращает true, если что-то сработало.
export async function shareApp({
  url = config.generatedBaseLink,
  text = "",
  title = "Wepurplay",
  sentryTag = "shareApp",
} = {}) {
  try {
    if (window.isRNWebView) {
      window.postMessage(
        JSON.stringify({
          type: "SHARE_API",
          data: { title, text, url },
        }),
        "*"
      );
      return true;
    }

    if (navigator.share) {
      await navigator.share({ title, text, url });
      return true;
    }

    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(text ? `${text}\n${url}` : url);
      return true;
    }

    return false;
  } catch (error) {
    console.error(error);
    Sentry.captureException(error, {
      tags: { component: sentryTag },
      level: "warning",
    });
    return false;
  }
}
